
























import { Vue, Component, Prop } from 'vue-property-decorator';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import { Technology } from '@/store/modules/commonInterfaces';

@Component({
  components: {
    DeleteIcon,
    SelectionField
  }
})
export default class TagSelector extends Vue {
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) hasError!: boolean;
  @Prop(String) placeholder!: string;
  @Prop(Array) value!: Technology[];
  @Prop(Array) items!: Technology[];

  item: Technology | null = null;

  addTag(item: Technology) {
    if (!item) {
      return;
    }

    this.item = item;
    this.$emit('add', item);
  }

  removeTag(index: number) {
    this.item = null;
    this.$emit('remove', index);
  }
}
